import { axiosInstance } from "./config";

export const apiCheckFiscalCode = async (fiscalCode) => {
    console.log('API - checking fiscal code', fiscalCode);
    try {
        let response = await axiosInstance({
            url: '/soggetto',
            method: 'POST',
            data: {
                cf: fiscalCode
            }
        });
        return response.data.attivo;
    } catch (error) {
        console.log('API - Error checking fiscal code', error);
        throw(error);
    }
}